// import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    canPlaceOrder,
    canSubmitForApprovalOrder,
    getCartState,
    getCurrentCartState,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getCurrentPromotionsDataView } from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const currentPromotionsDataView = getCurrentPromotionsDataView(state);
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    return {
        cartId,
        isBackButtonDisabled: state.pages.checkoutReviewAndSubmit.isPlacingOrder,
        checkoutShippingPageLink: getPageLinkByPageType(state, "CheckoutShippingPage"),
        cart: cartState.value,
        showPlaceOrderButton: canPlaceOrder(cartState.value),
        showSubmitForApprovalOrder: canSubmitForApprovalOrder(cartState.value),
        pageTitle: getCurrentPage(state).fields.title,
        promotions: currentPromotionsDataView.value,
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface CartPromoHeaderStyles {
    container?: GridContainerProps;
    gridItem?: GridItemProps;
    promoText?: TypographyPresentationProps;
    containerWrapper?: InjectableCss;
    promoLink?: LinkPresentationProps;
}

export const cartPromoHeaderStyles: CartPromoHeaderStyles = {
    gridItem: {
        width: 12,
        css: css`
            padding-top: 0;
            justify-content: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css`
                        margin-left: calc((100vw - 92vw) * -1) !important;
                    `,
                    css`
                        margin-left: calc((100vw - 92vw) * -1) !important;
                    `,
                    css`
                        margin-left: calc((100vw - 92vw) * -1) !important;
                    `,
                ])}
        `,
    },
    promoText: {
        css: css`
            padding: 10px;
            box-shadow: 0px 0px 4px 2px rgb(0 0 0 / 20%);
            background-color: rgb(251 241 200);
            display: inline-flex;
            flex-wrap: wrap;
            justify-content: center;
        `,
    },
    promoLink: {
        css: css`
            text-align: center;
            padding-left: 5px;
            padding-right: 5px;
            text-decoration: underline;
        `,
    },
};

export const header = cartPromoHeaderStyles;
const styles = cartPromoHeaderStyles;

const CartPromoHeader: FC<Props> = ({ pageTitle, cart, cartId, promotions }) => {
    let hasPromotions = false;
    let hasSwagPromotion = false;
    let result = 0;
    if (cart !== undefined && cart?.cartLines !== undefined) {
        hasPromotions = cart!.cartLines!.some(line => {
            return line.isPromotionItem;
        });

        if (promotions) {
            hasSwagPromotion = promotions!.some(promo => {
                return promo.name.toLocaleLowerCase() === "free swag";
            });
        }

        if (hasSwagPromotion) {
            return null;
        }

        result = cart!.cartLines!.reduce((total, line) => total + line?.pricing?.extendedUnitNetPrice!, 0);
    }

    if (result === 0) {
        return null;
    }

    return (
        <GridContainer {...styles.container} data-test-selector="cartPromo_header">
            <GridItem {...styles.gridItem}>
                {!hasSwagPromotion && result >= 150 ? (
                    <Typography {...styles.promoText} as="p">
                        {translate("Your order qualifies for a")}
                        <Link {...styles.promoLink} href="catalog/free-offers" as="a">
                            {translate("Free Swag")}
                        </Link>
                        {translate("gift")}
                    </Typography>
                ) : (
                    <Typography {...styles.promoText} as="p">
                        {translate("Orders of $150+ qualify for a")}
                        <Link {...styles.promoLink} href="catalog/free-offers" as="a">
                            {translate("Free Swag")}
                        </Link>
                        {translate("gift")}
                    </Typography>
                )}
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CartPromoHeader),
    definition: {
        group: "Cart",
        allowedContexts: ["CartPage"],
        displayName: "Cart Promo Header",
    },
};

export default widgetModule;
